import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Raven from 'raven-js';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

//import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';

import Ionicon from 'react-ionicons';
import styles from './styles';

// Custom Components
import LoginBlock from '../../components/LoginBlock';

import api from '../../api';

import chrono from 'chrono-node';
import moment from 'moment';

const UNIT = {
  HEADS: 'Heads',
  BUNCHES: 'Bunches',
  KGS: 'Kgs'
};

/**
 *  Donations Log Page
 */
class Donations extends Component {
  state = {
    donations: [],
    page: 0,
    donationCount: 0,
    itemsPerPage: 0
  };

  componentDidMount() {
    this._fetchDonations(); // Load/Search Donations
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  _fetchDonations = (page = 0) => {
    api
      .getMyDonations({ page })
      .then(data => {
        // console.log(data);
        /**
         *
         * Oh the dankness
         */
        data.results = data.results.map(e => {
          if (e.units && e.units.length > 0) {
            e.units.map((bb, index) => {
              e[e.units[index]] = e.unit_values[index];
            });
          }
          return e;
        });

        this.setState({
          page: Number(data.metadata.current_page),
          donations: data.results,
          metadata: data.metadata,
          donationCount: Number(data.metadata.total_results),
          itemsPerPage: Number(data.metadata.items_per_page)
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  _renderDonations = () => {
    const { donations } = this.state;
    const { user } = this.props;

    return donations.map(d => {
      const lengthOfArrays = d.unit_values.length;
      let kgs = 0;
      let heads = 0;
      let bunches = 0;
      // GROUP BY UNITS
      for (let i = 0; i < lengthOfArrays; i++) {
        if (d.units[i] === UNIT.HEADS) heads += +d.unit_values[i];
        else if (d.units[i] === UNIT.BUNCHES) bunches += +d.unit_values[i];
        else if (d.units[i] === UNIT.KGS) kgs += +d.unit_values[i];
      }
      return (
        <TableRow key={d.nid}>
          <TableCell>{d.Receipt}</TableCell>
          <TableCell>
            {moment(chrono.parseDate(d.created)).calendar(null, {
              sameElse: 'DD/MM/YYYY'
            })}
          </TableCell>
          <TableCell>{d.organisation_name}</TableCell>
          <TableCell>{kgs || '-'}</TableCell>
          <TableCell>{bunches || '-'}</TableCell>
          <TableCell>{heads || '-'}</TableCell>
          <TableCell>{d.Meals || '-'}</TableCell>
        </TableRow>
      );
    });
  };

  _handleGoBack = () => {
    this.props.changePage('/profile');
  };

  _handleChangePage = (event, page) => {
    // console.log(page);
    this._fetchDonations(page);
  };

  render() {
    const { loggedIn, classes } = this.props;

    if (!loggedIn) {
      return <LoginBlock />;
    }

    const {
      mealCount,
      donations,
      page,
      donationCount,
      itemsPerPage
    } = this.state;

    return (
      <Grid container className={classes.root} spacing={0}>
        <span className={classes.backButton} onClick={this._handleGoBack}>
          <Ionicon
            icon="md-arrow-back"
            style={{
              marginRight: 5,
              marginBottom: 2,
              color: '#122B4F'
            }}
          />
          Back
        </span>

        <Grid item xs={12}>
          <div style={{ height: 50 }} />
          <h1 className={classes.title}>My Donation Log</h1>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Paper className={classes.paper}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Receipt #</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Agency</TableCell>
                  <TableCell>Kgs</TableCell>
                  <TableCell>Bunches</TableCell>
                  <TableCell>Heads</TableCell>
                  <TableCell>Meals</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{this._renderDonations()}</TableBody>
            </Table>

            <TablePagination
              component="div"
              count={donationCount}
              rowsPerPage={itemsPerPage}
              rowsPerPageOptions={[]}
              page={page}
              backIconButtonProps={{
                'aria-label': 'Previous Page'
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page'
              }}
              onChangePage={this._handleChangePage}
              onChangeRowsPerPage={this._handleChangeRowsPerPage}
              classes={{
                toolbar: classes.tablePagination
              }}
            />
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

Donations = withStyles(styles)(Donations);

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn,
  user: state.user.data
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: url => push(url)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Donations);



// WEBPACK FOOTER //
// ./src/containers/donations/index.js